module.exports = __webpack_public_path__ + "media/images/wedding/lp/theme/ogp-05de41eada0b02c582731577316e713c.jpg";